// Generated by purs version 0.15.16
import * as App_Step from "../App.Step/index.js";
import * as App_UrlPrefix from "../App.UrlPrefix/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Steps_WorkQueue_Cache from "../Steps.WorkQueue.Cache/index.js";
import * as Steps_WorkQueue_DocumentIndex from "../Steps.WorkQueue.DocumentIndex/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var elem = /* #__PURE__ */ Data_Array.elem(Data_Eq.eqString);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var nub = /* #__PURE__ */ Data_Array.nub(/* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString));
var nub1 = /* #__PURE__ */ Data_Array.nub(Data_Ord.ordString);
var notEq = /* #__PURE__ */ Data_Eq.notEq(/* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString));
var SectionUnspecified = /* #__PURE__ */ (function () {
    function SectionUnspecified() {

    };
    SectionUnspecified.value = new SectionUnspecified();
    return SectionUnspecified;
})();
var SectionClear = /* #__PURE__ */ (function () {
    function SectionClear() {

    };
    SectionClear.value = new SectionClear();
    return SectionClear;
})();
var SectionSet = /* #__PURE__ */ (function () {
    function SectionSet(value0) {
        this.value0 = value0;
    };
    SectionSet.create = function (value0) {
        return new SectionSet(value0);
    };
    return SectionSet;
})();
var PreservedQuery = function (x) {
    return x;
};
var RHome = /* #__PURE__ */ (function () {
    function RHome(value0) {
        this.value0 = value0;
    };
    RHome.create = function (value0) {
        return new RHome(value0);
    };
    return RHome;
})();
var RStep2A = /* #__PURE__ */ (function () {
    function RStep2A(value0) {
        this.value0 = value0;
    };
    RStep2A.create = function (value0) {
        return new RStep2A(value0);
    };
    return RStep2A;
})();
var RStep2B = /* #__PURE__ */ (function () {
    function RStep2B(value0) {
        this.value0 = value0;
    };
    RStep2B.create = function (value0) {
        return new RStep2B(value0);
    };
    return RStep2B;
})();
var RStep3 = /* #__PURE__ */ (function () {
    function RStep3(value0) {
        this.value0 = value0;
    };
    RStep3.create = function (value0) {
        return new RStep3(value0);
    };
    return RStep3;
})();
var RPreview = /* #__PURE__ */ (function () {
    function RPreview(value0) {
        this.value0 = value0;
    };
    RPreview.create = function (value0) {
        return new RPreview(value0);
    };
    return RPreview;
})();
var RTestForm = /* #__PURE__ */ (function () {
    function RTestForm(value0) {
        this.value0 = value0;
    };
    RTestForm.create = function (value0) {
        return new RTestForm(value0);
    };
    return RTestForm;
})();
var step3DocPath = function (path) {
    return bind(Data_String_CodeUnits.stripPrefix("/step3/")(path))(function (docPart) {
        var $40 = Data_String_Common["null"](docPart) || Data_String_CodeUnits.contains("/")(docPart);
        if ($40) {
            return Data_Maybe.Nothing.value;
        };
        return new Data_Maybe.Just(GraphQL_Type.typedId(docPart));
    });
};
var step3ActiveDocId = function (workQ) {
    return bind(workQ.currentDoc)(function (lookup) {
        if (lookup.documentId instanceof Data_Maybe.Just) {
            return new Data_Maybe.Just(lookup.documentId.value0);
        };
        if (lookup.documentId instanceof Data_Maybe.Nothing) {
            return map(function (v) {
                return v.id;
            })(Steps_WorkQueue_Cache.getDocByStudent(workQ)(lookup));
        };
        throw new Error("Failed pattern match at App.Route (line 294, column 5 - line 296, column 57): " + [ lookup.documentId.constructor.name ]);
    });
};
var routedParams = [ "forms", "students", "docs" ];
var routeToStep = function (v) {
    if (v instanceof RHome) {
        return App_Step.Step1.value;
    };
    if (v instanceof RStep2A) {
        return App_Step.Step2A.value;
    };
    if (v instanceof RStep2B) {
        return App_Step.Step2B.value;
    };
    if (v instanceof RStep3 && v.value0.activeDoc instanceof Data_Maybe.Nothing) {
        return App_Step.Step3.value;
    };
    if (v instanceof RStep3 && v.value0.activeDoc instanceof Data_Maybe.Just) {
        return new App_Step.Step3Doc(v.value0.activeDoc.value0);
    };
    if (v instanceof RPreview) {
        return new App_Step.Preview(v.value0.index);
    };
    if (v instanceof RTestForm) {
        return App_Step.TestForm.value;
    };
    throw new Error("Failed pattern match at App.Route (line 105, column 15 - line 112, column 28): " + [ v.constructor.name ]);
};
var routeTag = function (v) {
    if (v instanceof RHome) {
        return "Home";
    };
    if (v instanceof RStep2A) {
        return "Step2A";
    };
    if (v instanceof RStep2B) {
        return "Step2B";
    };
    if (v instanceof RStep3 && v.value0.activeDoc instanceof Data_Maybe.Nothing) {
        return "Step3";
    };
    if (v instanceof RStep3 && v.value0.activeDoc instanceof Data_Maybe.Just) {
        return "Step3:" + GraphQL_Type.innerId(v.value0.activeDoc.value0);
    };
    if (v instanceof RPreview) {
        return "Preview:" + show(v.value0.index);
    };
    if (v instanceof RTestForm) {
        return "TestForm";
    };
    throw new Error("Failed pattern match at App.Route (line 95, column 12 - line 102, column 30): " + [ v.constructor.name ]);
};
var routePreservedQuery = function (v) {
    if (v instanceof RHome) {
        return v.value0.preservedQuery;
    };
    if (v instanceof RStep2A) {
        return v.value0.preservedQuery;
    };
    if (v instanceof RStep2B) {
        return v.value0.preservedQuery;
    };
    if (v instanceof RStep3) {
        return v.value0.preservedQuery;
    };
    if (v instanceof RPreview) {
        return v.value0.preservedQuery;
    };
    if (v instanceof RTestForm) {
        return v.value0;
    };
    throw new Error("Failed pattern match at App.Route (line 115, column 23 - line 121, column 47): " + [ v.constructor.name ]);
};
var renderHash = function (v) {
    if (v instanceof SectionSet) {
        return "#" + v.value0;
    };
    if (v instanceof SectionClear) {
        return "";
    };
    if (v instanceof SectionUnspecified) {
        return "";
    };
    throw new Error("Failed pattern match at App.Route (line 228, column 14 - line 231, column 29): " + [ v.constructor.name ]);
};
var sectionHash = /* #__PURE__ */ Data_Maybe.maybe("")(function ($140) {
    return renderHash(SectionSet.create($140));
});
var previewPath = function (path) {
    return bind(Data_String_CodeUnits.stripPrefix("/preview/")(path))(function (indexPart) {
        return Data_Int.fromString(indexPart);
    });
};
var preservedQueryParts = function (v) {
    return v;
};
var renderSearch = function (preserved) {
    return function (routedParams$prime) {
        var renderParam = function (v) {
            var v1 = Data_Array.filter(function ($141) {
                return !Data_String_Common["null"]($141);
            })(v.value1);
            if (v1.length === 0) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(v.value0 + ("=" + Data_String_Common.joinWith(",")(v1)));
        };
        var routedParts = Data_Array.catMaybes(map1(renderParam)(routedParams$prime));
        var preservedParts = preservedQueryParts(preserved);
        var v = append1(routedParts)(preservedParts);
        if (v.length === 0) {
            return "";
        };
        return "?" + Data_String_Common.joinWith("&")(v);
    };
};
var preserveQuery = function (search) {
    var isRoutedParam = function (part) {
        var v = Data_String_Common.split("=")(part);
        if (v.length === 2) {
            return elem(v[0])(routedParams);
        };
        if (v.length === 1) {
            return elem(v[0])(routedParams);
        };
        return false;
    };
    var v = Data_String_CodeUnits.stripPrefix("?")(search);
    if (v instanceof Data_Maybe.Nothing) {
        return [  ];
    };
    if (v instanceof Data_Maybe.Just) {
        return Data_Array.filter(function ($142) {
            return !isRoutedParam($142);
        })(Data_String_Common.split("&")(v.value0));
    };
    throw new Error("Failed pattern match at App.Route (line 130, column 41 - line 132, column 81): " + [ v.constructor.name ]);
};
var routeForStepAndWorkQueueState = function (locationState) {
    return function (step) {
        return function (workQ) {
            var selectedStudents = map1(function (v) {
                return v.id;
            })(fromFoldable(Internal_SelectionMap.listSelected(workQ.students)));
            var selectedForms = map1(function (v) {
                return v.id;
            })(fromFoldable(Internal_SelectionMap.listSelected(workQ.forms)));
            var preservedQuery = preserveQuery(locationState.search);
            var loadedDocIds = nub(map1(function (v) {
                return v.id;
            })(fromFoldable(Steps_WorkQueue_DocumentIndex.listDocs(workQ.documents))));
            var editDocIds = nub(map1(function (v) {
                return v.id;
            })(workQ.editDocs));
            var routeDocIds = nub(append1(editDocIds)(loadedDocIds));
            var activeDoc = step3ActiveDocId(workQ);
            if (step instanceof App_Step.Step1) {
                return new RHome({
                    preservedQuery: preservedQuery
                });
            };
            if (step instanceof App_Step.Step2A) {
                return new RStep2A({
                    preservedQuery: preservedQuery,
                    selectedForms: selectedForms
                });
            };
            if (step instanceof App_Step.Step2B) {
                return new RStep2B({
                    preservedQuery: preservedQuery,
                    selectedStudents: selectedStudents,
                    selectedForms: selectedForms
                });
            };
            if (step instanceof App_Step.Step3) {
                return new RStep3({
                    preservedQuery: preservedQuery,
                    activeDoc: activeDoc,
                    docs: routeDocIds,
                    section: SectionUnspecified.value
                });
            };
            if (step instanceof App_Step.Step3Doc) {
                return new RStep3({
                    preservedQuery: preservedQuery,
                    activeDoc: new Data_Maybe.Just(step.value0),
                    docs: nub(Data_Array.cons(step.value0)(routeDocIds)),
                    section: SectionUnspecified.value
                });
            };
            if (step instanceof App_Step.Preview) {
                return new RPreview({
                    index: step.value0,
                    preservedQuery: preservedQuery
                });
            };
            if (step instanceof App_Step.TestForm) {
                return new RTestForm(preservedQuery);
            };
            if (step instanceof App_Step.Step4) {
                return new RHome({
                    preservedQuery: preservedQuery
                });
            };
            throw new Error("Failed pattern match at App.Route (line 207, column 8 - line 215, column 42): " + [ step.constructor.name ]);
        };
    };
};
var parseSectionHash = function (hash) {
    var v = Data_String_CodeUnits.stripPrefix("#")(hash);
    if (v instanceof Data_Maybe.Just && Data_String_Common["null"](v.value0)) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof Data_Maybe.Just) {
        return new Data_Maybe.Just(v.value0);
    };
    if (v instanceof Data_Maybe.Nothing && Data_String_Common["null"](hash)) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof Data_Maybe.Nothing) {
        return new Data_Maybe.Just(hash);
    };
    throw new Error("Failed pattern match at App.Route (line 218, column 25 - line 222, column 25): " + [ v.constructor.name ]);
};
var parseQueryValues = function (key) {
    return function (search) {
        var splitValues = function (value) {
            return Data_Array.filter(function ($143) {
                return !Data_String_Common["null"]($143);
            })(map1(Data_String_Common.trim)(Data_String_Common.split(",")(value)));
        };
        var extractValue = function (part) {
            var v = Data_String_Common.split("=")(part);
            if (v.length === 2 && v[0] === key) {
                return new Data_Maybe.Just(v[1]);
            };
            if (v.length === 1 && v[0] === key) {
                return new Data_Maybe.Just("");
            };
            return Data_Maybe.Nothing.value;
        };
        var values = (function () {
            var v = Data_String_CodeUnits.stripPrefix("?")(search);
            if (v instanceof Data_Maybe.Nothing) {
                return [  ];
            };
            if (v instanceof Data_Maybe.Just) {
                return Data_Array.catMaybes(map1(extractValue)(Data_String_Common.split("&")(v.value0)));
            };
            throw new Error("Failed pattern match at App.Route (line 246, column 14 - line 248, column 83): " + [ v.constructor.name ]);
        })();
        return nub1(Data_Array.concatMap(splitValues)(values));
    };
};
var parseStudentsQuery = /* #__PURE__ */ (function () {
    var $144 = map1(GraphQL_Type.typedId);
    var $145 = parseQueryValues("students");
    return function ($146) {
        return $144($145($146));
    };
})();
var parseFormsQuery = /* #__PURE__ */ (function () {
    var $147 = map1(GraphQL_Type.typedId);
    var $148 = parseQueryValues("forms");
    return function ($149) {
        return $147($148($149));
    };
})();
var parseDocsQuery = /* #__PURE__ */ (function () {
    var $150 = map1(GraphQL_Type.typedId);
    var $151 = parseQueryValues("docs");
    return function ($152) {
        return $150($151($152));
    };
})();
var hrUrlPrefix = App_UrlPrefix.hrUrlPrefix;
var normalisedPath = function (pathname) {
    var stripped = (function () {
        if (hrUrlPrefix === "") {
            return pathname;
        };
        return Data_Maybe.fromMaybe(pathname)(Data_String_CodeUnits.stripPrefix("/" + hrUrlPrefix)(pathname));
    })();
    var $106 = Data_String_Common["null"](stripped);
    if ($106) {
        return "/";
    };
    return stripped;
};
var parseRoute = function (locationState) {
    var students = parseStudentsQuery(locationState.search);
    var section = (function () {
        var v = parseSectionHash(locationState.hash);
        if (v instanceof Data_Maybe.Just) {
            return new SectionSet(v.value0);
        };
        if (v instanceof Data_Maybe.Nothing) {
            return SectionClear.value;
        };
        throw new Error("Failed pattern match at App.Route (line 154, column 19 - line 156, column 36): " + [ v.constructor.name ]);
    })();
    var preservedQuery = preserveQuery(locationState.search);
    var path = normalisedPath(locationState.pathname);
    var forms = parseFormsQuery(locationState.search);
    var docs = parseDocsQuery(locationState.search);
    if (path === "/step2") {
        return new RStep2A({
            preservedQuery: preservedQuery,
            selectedForms: forms
        });
    };
    if (path === "/step2b") {
        return new RStep2B({
            preservedQuery: preservedQuery,
            selectedStudents: students,
            selectedForms: forms
        });
    };
    if (path === "/step3") {
        return new RStep3({
            preservedQuery: preservedQuery,
            activeDoc: Data_Maybe.Nothing.value,
            docs: docs,
            section: section
        });
    };
    if (path === "/test-form") {
        return new RTestForm(preservedQuery);
    };
    var v = step3DocPath(path);
    if (v instanceof Data_Maybe.Just) {
        return new RStep3({
            preservedQuery: preservedQuery,
            activeDoc: new Data_Maybe.Just(v.value0),
            docs: nub(Data_Array.cons(v.value0)(docs)),
            section: section
        });
    };
    if (v instanceof Data_Maybe.Nothing) {
        var v1 = previewPath(path);
        if (v1 instanceof Data_Maybe.Just) {
            return new RPreview({
                index: v1.value0,
                preservedQuery: preservedQuery
            });
        };
        if (v1 instanceof Data_Maybe.Nothing) {
            return new RHome({
                preservedQuery: preservedQuery
            });
        };
        throw new Error("Failed pattern match at App.Route (line 165, column 24 - line 167, column 52): " + [ v1.constructor.name ]);
    };
    throw new Error("Failed pattern match at App.Route (line 163, column 14 - line 167, column 52): " + [ v.constructor.name ]);
};
var urlPrefix = /* #__PURE__ */ (function () {
    if (hrUrlPrefix === "") {
        return "";
    };
    return "/" + hrUrlPrefix;
})();
var rootPath = /* #__PURE__ */ (function () {
    if (urlPrefix === "") {
        return "/";
    };
    return urlPrefix;
})();
var routeUrl = function (v) {
    if (v instanceof RHome) {
        return rootPath + (renderSearch(v.value0.preservedQuery)([  ]) + "");
    };
    if (v instanceof RStep2A) {
        return urlPrefix + ("/step2" + (renderSearch(v.value0.preservedQuery)([ new Data_Tuple.Tuple("forms", map1(GraphQL_Type.innerId)(v.value0.selectedForms)) ]) + ""));
    };
    if (v instanceof RStep2B) {
        return urlPrefix + ("/step2b" + (renderSearch(v.value0.preservedQuery)([ new Data_Tuple.Tuple("students", map1(GraphQL_Type.innerId)(v.value0.selectedStudents)), new Data_Tuple.Tuple("forms", map1(GraphQL_Type.innerId)(v.value0.selectedForms)) ]) + ""));
    };
    if (v instanceof RStep3) {
        var path = (function () {
            if (v.value0.activeDoc instanceof Data_Maybe.Nothing) {
                return urlPrefix + "/step3";
            };
            if (v.value0.activeDoc instanceof Data_Maybe.Just) {
                return urlPrefix + ("/step3/" + GraphQL_Type.innerId(v.value0.activeDoc.value0));
            };
            throw new Error("Failed pattern match at App.Route (line 183, column 20 - line 185, column 70): " + [ v.value0.activeDoc.constructor.name ]);
        })();
        var otherDocs = (function () {
            if (v.value0.activeDoc instanceof Data_Maybe.Nothing) {
                return nub(v.value0.docs);
            };
            if (v.value0.activeDoc instanceof Data_Maybe.Just) {
                return Data_Array.filter(function (v1) {
                    return notEq(v1)(v.value0.activeDoc.value0);
                })(nub(v.value0.docs));
            };
            throw new Error("Failed pattern match at App.Route (line 186, column 25 - line 188, column 69): " + [ v.value0.activeDoc.constructor.name ]);
        })();
        var params = (function () {
            var $130 = Data_Array["null"](otherDocs);
            if ($130) {
                return [  ];
            };
            return [ new Data_Tuple.Tuple("docs", map1(GraphQL_Type.innerId)(otherDocs)) ];
        })();
        return path + (renderSearch(v.value0.preservedQuery)(params) + renderHash(v.value0.section));
    };
    if (v instanceof RPreview) {
        return urlPrefix + ("/preview/" + (show(v.value0.index) + (renderSearch(v.value0.preservedQuery)([  ]) + "")));
    };
    if (v instanceof RTestForm) {
        return urlPrefix + ("/test-form" + (renderSearch(v.value0)([  ]) + ""));
    };
    throw new Error("Failed pattern match at App.Route (line 170, column 12 - line 196, column 74): " + [ v.constructor.name ]);
};
export {
    RHome,
    RStep2A,
    RStep2B,
    RStep3,
    RPreview,
    RTestForm,
    PreservedQuery,
    SectionUnspecified,
    SectionClear,
    SectionSet,
    parseRoute,
    routeToStep,
    routeTag,
    routeUrl,
    routePreservedQuery,
    routeForStepAndWorkQueueState,
    preserveQuery,
    preservedQueryParts,
    parseDocsQuery,
    parseFormsQuery,
    parseStudentsQuery,
    parseSectionHash,
    sectionHash,
    urlPrefix,
    hrUrlPrefix
};
//# sourceMappingURL=index.js.map
